/**
 * Vanilla replacement for jQuery's slideToggle: animates an element's
 * height between 0 and its natural height, toggling `display` at the
 * boundaries.
 */
export default function slideToggle(el, duration = 200) {
  if (el.dataset.sliding) {
    return;
  }
  el.dataset.sliding = 'true';

  const isOpen = getComputedStyle(el).display !== 'none';
  const finish = () => {
    el.style.overflow = '';
    delete el.dataset.sliding;
  };

  el.style.overflow = 'hidden';

  if (isOpen) {
    const animation = el.animate(
      [{ height: `${el.offsetHeight}px` }, { height: '0px' }],
      { duration }
    );
    animation.onfinish = () => {
      el.style.display = 'none';
      finish();
    };
  } else {
    el.style.display = 'block';
    const animation = el.animate(
      [{ height: '0px' }, { height: `${el.offsetHeight}px` }],
      { duration }
    );
    animation.onfinish = finish;
  }
}
